import useCurrentCountry from './useCurrentCountry';
import { useDataSourceVersion } from './useDataSourceVersion';

function useTikTokWeeks() {
    const country = useCurrentCountry();
    const { tiktokVersion: query } = useDataSourceVersion();
    const { week, year } = query.data?.countries?.[country?.text_id] || {};
    return { week, year, query };
}

export default useTikTokWeeks;
